import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-conversation" }

import NConversationThread from './conversation-thread.vue';
import NMessageComposer from './message-composer.vue';
import { Message } from './message';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-conversation',
},
  __name: 'conversation',
  props: {
  messages: {
    type: Array as PropType<Message[]>,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
},
  emits: ["messageSend", "sendQuickReply", "conversationRead", "typingStart", "typingStop"],
  setup(__props, { emit: __emit }) {



const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NConversationThread, {
      messages: __props.messages,
      outboundMessageColour: __props.outboundMessageColour,
      displayAvatar: __props.displayAvatar,
      enableAvatarTooltip: __props.enableAvatarTooltip,
      readonlyApps: __props.readonlyApps,
      onSendQuickReply: _cache[0] || (_cache[0] = (quickReply) => emit('sendQuickReply', quickReply))
    }, null, 8, ["messages", "outboundMessageColour", "displayAvatar", "enableAvatarTooltip", "readonlyApps"]),
    _createVNode(NMessageComposer, {
      accentColour: __props.outboundMessageColour,
      onMessageSend: _cache[1] || (_cache[1] = (messageText) => emit('messageSend', messageText)),
      onConversationRead: _cache[2] || (_cache[2] = ($event: any) => (emit('conversationRead'))),
      onTypingStart: _cache[3] || (_cache[3] = ($event: any) => (emit('typingStart'))),
      onTypingStop: _cache[4] || (_cache[4] = ($event: any) => (emit('typingStop')))
    }, null, 8, ["accentColour"])
  ]))
}
}

})